export const formatAndLimitDisplay = (
  input: string[] | null,
  limit: number = 5,
  expanded: boolean = false,
): { text: string; hasMore: boolean } => {
  // Handle null, undefined or empty cases
  if (!input || input.length === 0) {
    return { text: '', hasMore: false };
  }

  // If expanded or doesn't exceed limit, show all items
  if (expanded || input.length <= limit) {
    return { text: input.join(', '), hasMore: input.length > limit };
  }

  // Show limited items with +X more indicator
  const limitedItems = input.slice(0, limit);
  return {
    text: `${limitedItems.join(', ')} +${input.length - limit} more`,
    hasMore: true,
  };
};

export const truncateText = (
  text: string | null | undefined,
  limit: number = 100,
  expanded: boolean = false,
): { displayText: string; hasMore: boolean } => {
  // Handle null, undefined or empty cases
  if (!text) {
    return { displayText: '', hasMore: false };
  }
  // If expanded or doesn't exceed limit, show all text
  if (expanded || text.length <= limit) {
    return { displayText: text, hasMore: text.length > limit };
  }
  // Truncate at the nearest word boundary before the limit
  const truncated = text.substring(0, limit);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  const breakPoint = lastSpaceIndex > limit * 0.8 ? lastSpaceIndex : limit;
  return {
    displayText: `${text.substring(0, breakPoint)}...`,
    hasMore: true,
  };
};

export const toSentenceCase = (text: string | null | undefined): string => {
  if (!text) return '';
  if (text.indexOf('_') !== -1) return toTitleCase(text.replaceAll('_', ' '));
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const toTitleCase = (text: string | null | undefined): string => {
  if (!text) return '';
  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};

export const formatNumberAsMoney = (number: any, currency: string, noOfDP: number = 2) => {
  const formatLocale = new Intl.NumberFormat().resolvedOptions().locale || 'en-US';
  return new Intl.NumberFormat(formatLocale, {
    style: 'currency',
    currency: currency || 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: noOfDP,
    maximumFractionDigits: noOfDP,
  }).format(parseFloat(number || '0'));
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.toDateString()}, ${date.toLocaleTimeString()}`;
};
